<template>
  <div>
    <v-row no-gutters class="mb-2" v-if="xconceptos.length > 0">
      <v-col cols="12" class="pb-0 mt-4">
        <button
          :disabled="$store.state.isonlyread"
          class="btn btn-sm btn-link"
          @click="tableToExcel('table', 'Lorem Table')"
        >
          <span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL
        </button>
        <p class="mb-0 blue--text"><b>Seleccione los conceptos para ver la asignacion.</b></p>
      </v-col>
      <v-col cols="2" v-for="(c, ind) in xconceptos" :key="ind">
        <v-checkbox
          class="pt-0 mt-0"
          v-model="xconcetoschecks"
          :label="c.descripcion"
          :value="c.concepto_pago_id"
          :color="ind % 2 == 0 ? '#7A3674' : '#1F6E43'"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col cols="4">
        <v-switch
          v-model="hide_ceros"
          :label="hide_ceros ? 'Mostrar todo' : 'Ocultar filas vacias'"
          :disabled="xconceptos.length == 0 || xconcetoschecks.length > 1"
          dense
          hide-details
          title="Mostrar datos de la fila."
          class="mb-0 pt-0 mt-0"
        ></v-switch>
      </v-col>
    </v-row>

    <div v-if="xconceptos.length > 0">
      <v-simple-table dense ref="table">
        <template v-slot:default>
          <thead>
            <tr>
              <th :key="'k-3'" class="fixedheader"></th>
              <th :key="'k-2'" class="fixedheader"></th>
              <th :key="'k-2a'" class="fixedheader" style="max-width: 40px;"></th>
              <th :key="'k-2b'" class="fixedheader" style="max-width: 40px;"></th>
              <th :key="'k-2c'" class="fixedheader" style="max-width: 40px;"></th>
              <template v-for="(k, ind2) in xconceptos">
                <th v-if="isconceptosel(k)" :key="'k-1' + ind2" :style="getcolor(ind2)"></th>
                <th v-if="isconceptosel(k)" :key="'k0' + ind2" :style="getcolor(ind2)" class="text-center" :colspan="colspanconcepto()">
                  {{ k.descripcion }}
                </th>
              </template>
            </tr>
            <tr>
              <th :key="'k-5'" class="fixedheader"></th>
              <th :key="'k-4'" class="fixedheader"></th>
              <th :key="'k-4a'" class="fixedheader" style="max-width: 40px;"></th>
              <th :key="'k-4b'" class="fixedheader" style="max-width: 40px;"></th>
              <th :key="'k-4c'" class="fixedheader" style="max-width: 40px;"></th>
              <template v-for="(k, ind2) in xconceptos">
                <th v-if="isconceptosel(k)" :key="'k-2' + ind2" :style="getcolor(ind2)" style="border-right:1px solid #000000" rowspan="2">Total {{ k.descripcion }}</th>
                <th v-if="isconceptosel(k)" :key="'kzx-2' + ind2" :style="getcolor(ind2)" style="border-right:1px solid #000000" rowspan="2">Total Asignacion </th>
                <th v-if="isconceptosel(k) && show_retrasado" :key="'ks0' + ind2" :style="getcolor(ind2)" class="text-center" colspan="3" style="border-right:1px solid #000000">Retrasado</th>
                <th v-if="isconceptosel(k) && show_recuperar" :key="'ks1' + ind2" :style="getcolor(ind2)" class="text-center" colspan="3" style="border-right:1px solid #000000">Por recuperar</th>
                <th v-if="isconceptosel(k)" :key="'ks2' + ind2" :style="getcolor(ind2)" class="text-center" colspan="3" style="border-right:1px solid #000000">Vigente</th>
                <th v-if="isconceptosel(k)" :key="'k-1' + ind2" :style="getcolor(ind2)" class="text-center" colspan="1" style="border-right:1px solid #000000">Adelantado</th>
              </template>
            </tr>
            <tr>
              <th class="text-left white--text fixedheader" style="min-width:250px">Programas</th>
              <th class="text-left white--text fixedheader" style="min-width:250px">Codigo</th>
              <th class="text-left white--text fixedheader" style="min-width:50px">inscritos</th>
              <th class="text-left white--text fixedheader" style="min-width:50px">retirados</th>
              <th class="text-left white--text fixedheader" style="min-width:50px">cambiados</th>
              <template v-for="(k, ind2) in xconceptos">
                <th v-if="isconceptosel(k) && show_retrasado" :key="'k1' + ind2" :style="getcolor(ind2)" class="text-left">Cuota retrasada</th>
                <th v-if="isconceptosel(k) && show_retrasado" :key="'k2' + ind2" :style="getcolor(ind2)" class="text-left">Importe cobrado</th>
                <th v-if="isconceptosel(k) && show_retrasado" :key="'k3' + ind2" :style="getcolor(ind2)" class="text-left" style="border-right:1px solid #000000">Saldo por cobrar</th>
                <th v-if="isconceptosel(k) && show_recuperar" :key="'k4' + ind2" :style="getcolor(ind2)" class="text-left">Cuota por recuperar</th>
                <th v-if="isconceptosel(k) && show_recuperar" :key="'k5' + ind2" :style="getcolor(ind2)" class="text-left">Importe cobrado</th>
                <th v-if="isconceptosel(k) && show_recuperar" :key="'k6' + ind2" :style="getcolor(ind2)" class="text-left" style="border-right:1px solid #000000">Saldo por cobrar</th>
                <th v-if="isconceptosel(k)" :key="'k7' + ind2" :style="getcolor(ind2)" class="text-left">Cuota vigente</th>
                <th v-if="isconceptosel(k)" :key="'k8' + ind2" :style="getcolor(ind2)" class="text-left">Importe Cobrado</th>
                <th v-if="isconceptosel(k)" :key="'k9' + ind2" :style="getcolor(ind2)" class="text-left" style="border-right:1px solid #000000">Saldo por cobrar</th>
                <th v-if="isconceptosel(k)" :key="'k10' + ind2" :style="getcolor(ind2)" class="text-left">Importe</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, ind) in xprogramas" :key="ind">
              <td v-if="ismostrarFilaEstudiante(item)">
                <v-hover v-slot="{ hover }" open-delay="100">
                  <div>
                    <span> <b>{{ind+1}}.-</b> {{ item.nombre_compuesto }} </span>
                    <v-expand-transition>
                      <div v-if="hover" class="d-flex transition-fast-in-fast-out green darken-4 v-card--reveal white--text" style="height: 100%; width:90%">
                        <v-icon small @click="showMoreDetails(item)" title="Ver detalles" color="white" class="mr-4" >mdi-eye</v-icon>
                      </div>
                    </v-expand-transition>
                    <v-progress-linear v-if="item.loading" indeterminate color="white"></v-progress-linear>
                  </div>
                </v-hover>
              </td>
              <!-- <td v-if="ismostrarFilaEstudiante(item)">{{ item.nombre_compuesto }}</td> -->
              <td v-if="ismostrarFilaEstudiante(item)">{{ item.codigo }}</td>
              <td v-if="ismostrarFilaEstudiante(item)">{{ item.total_inscritos }}</td>
              <td v-if="ismostrarFilaEstudiante(item)">{{ item.total_retirados }}</td>
              <td v-if="ismostrarFilaEstudiante(item)">{{ item.total_cambiados }}</td>
              <template v-for="(k, ind2) in item.detalle_asignacion">
                <td v-if="(!hide_ceros || (!hide_ceros === k.xadd)) && isconceptosel(k)" class="text-right" :key="'1ind' + ind2">{{ parsecomas(k.total_por_cobrar) }} </td>
                <td v-if="(!hide_ceros || (!hide_ceros === k.xadd)) && isconceptosel(k)" class="text-right" :key="'io1ind' + ind2">{{ parsecomas(k.total_asignacion) }} </td>
                <td v-if="(!hide_ceros || (!hide_ceros === k.xadd)) && isconceptosel(k) && show_retrasado" class="text-right" :key="'7ind' + ind2">{{ parsecomas(k.retrasado) }}</td>
                <td v-if="(!hide_ceros || (!hide_ceros === k.xadd)) && isconceptosel(k) && show_retrasado" class="text-right" :key="'3ind' + ind2">{{ parsecomas(k.pagado_retrasado) }}</td>
                <td v-if="(!hide_ceros || (!hide_ceros === k.xadd)) && isconceptosel(k) && show_retrasado" class="text-right" :key="'9ind' + ind2">{{ parsecomas(k.saldo_retrasado) }}</td>
                <td v-if="(!hide_ceros || (!hide_ceros === k.xadd)) && isconceptosel(k) && show_recuperar" class="text-right" :key="'6ind' + ind2">{{ parsecomas(k.por_recuperar) }}</td>
                <td v-if="(!hide_ceros || (!hide_ceros === k.xadd)) && isconceptosel(k) && show_recuperar" class="text-right" :key="'2ind' + ind2">{{ parsecomas(k.pagado_por_recuperar) }}</td>
                <td v-if="(!hide_ceros || (!hide_ceros === k.xadd)) && isconceptosel(k) && show_recuperar" class="text-right" :key="'8ind' + ind2">{{ parsecomas(k.saldo_por_recuperar) }}</td>
                <td v-if="(!hide_ceros || (!hide_ceros === k.xadd)) && isconceptosel(k)" class="text-right" :key="'11ivnd' + ind2">{{ parsecomas(k.vigente) }}</td>
                <td v-if="(!hide_ceros || (!hide_ceros === k.xadd)) && isconceptosel(k)" class="text-right" :key="'4ind' + ind2">{{ parsecomas(k.pagado_vigente) }}</td>
                <td v-if="(!hide_ceros || (!hide_ceros === k.xadd)) && isconceptosel(k)" class="text-right" :key="'10ind' + ind2">{{ parsecomas(k.saldo_vigente) }}</td>
                <td v-if="(!hide_ceros || (!hide_ceros === k.xadd)) && isconceptosel(k)" class="text-right" :key="'5ind' + ind2">{{ parsecomas(k.pago_adelantado) }}</td>
              </template>
            </tr>
            <tr style="background:#1F6E43;color:white">
              <td style="background:#1F6E43;color:white"></td>
              <td style="background:#1F6E43;color:white">Totales </td>
              <td style="background:#1F6E43;color:white"> {{ totales[0]?totales[0].total_inscritos:'' }} </td>
              <td style="background:#1F6E43;color:white"> {{ totales[0]?totales[0].total_retirados:'' }} </td>
              <td style="background:#1F6E43;color:white"> {{ totales[0]?totales[0].total_cambiados:'' }} </td>
              <template v-for="(k, ind2) in totales"> 
                <td v-if="isconceptosel(k)" class="text-right" :key="'Dind' + ind2">{{ parsecomas(k.total_por_cobrar) }} </td>
                <td v-if="isconceptosel(k)" class="text-right" :key="'z1ind' + ind2">{{ parsecomas(k.total_asignacion) }} </td>
                <td v-if="isconceptosel(k) && show_retrasado" class="text-right" :key="'7ind' + ind2">{{ parsecomas(k.retrasado) }}</td>
                <td v-if="isconceptosel(k) && show_retrasado" class="text-right" :key="'3ind' + ind2">{{ parsecomas(k.pagado_retrasado) }}</td>
                <td v-if="isconceptosel(k) && show_retrasado" class="text-right" :key="'9ind' + ind2">{{ parsecomas(k.saldo_retrasado) }}</td>
                <td v-if="isconceptosel(k) && show_recuperar" class="text-right" :key="'6ind' + ind2">{{ parsecomas(k.por_recuperar) }}</td>
                <td v-if="isconceptosel(k) && show_recuperar" class="text-right" :key="'2ind' + ind2">{{ parsecomas(k.pagado_por_recuperar) }}</td>
                <td v-if="isconceptosel(k) && show_recuperar" class="text-right" :key="'8ind' + ind2">{{ parsecomas(k.saldo_por_recuperar) }}</td>
                <td v-if="isconceptosel(k)" class="text-right" :key="'11ind' + ind2">{{ parsecomas(k.vigente) }}</td>
                <td v-if="isconceptosel(k)" class="text-right" :key="'4ind' + ind2">{{ parsecomas(k.pagado_vigente) }}</td>
                <td v-if="isconceptosel(k)" class="text-right" :key="'10ind' + ind2">{{ parsecomas(k.saldo_vigente) }}</td>
                <td v-if="isconceptosel(k)" class="text-right" :key="'5ind' + ind2">{{ parsecomas(k.pago_adelantado) }}</td>
              </template>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <p class="text-center green--text">
      {{ msg }}
    </p>
  </div>
</template>

<style scoped>
  table tbody td:first-child {
    position: sticky;
    left: 0;
    background: #efefef;
    z-index: 0;
    text-align: left;
  }
  .fixedheader {
    position: sticky;
    left: 0;
    background: #196391;
    z-index: 1;
    text-align: left;
  }
  .xtable,
  tr,
  td {
    border: 1px solid #444;
  }

  .xtable td:last-child {
    border: 2px solid black;
  }

  tbody td:nth-child(2) {
    color: #000000;
  }
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: 1;
    position: absolute;
    width: 100%;
  }
</style>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        // EXCEL
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function(s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function(s, c) {
          return s.replace(/{(\w+)}/g, function(m, p) {
            return c[p];
          });
        },
        // END EXCEL
        msg: '',
        xconceptos: [],
        xprogramas: [],
        xconcetoschecks: [],
        totales: [],
        hide_ceros: false,
        show_retrasado: true,
        show_recuperar: true,
        fecha_fin: '',
      };
    },
    watch: {
      xconcetoschecks: {
        deep: true,
        handler(){
          this.hide_ceros = false;
        },
      }
    },
    components: {},
    computed: {},
    methods: {
      tableToExcel(table, name) {
        if(this.xconcetoschecks.length==0){
          this.$root.$notify.show(`Debe seleccionar al menos 1 concepto`, {color:'danger',x: 'left',});
          return;
        }
        if (!table.nodeType) table = this.$refs.table;
        var ctx = { worksheet: name || 'Worksheet', table: table.$el.childNodes[0].childNodes[0].innerHTML };
        var link = document.createElement('a');
        link.download = 'REPORTE_ASIGNACION_POR_SEDE_COBRANZA.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      getcolor(i) {
        if (i % 2 == 0) return 'background:#7A3674;color:white';
        else return 'background:#1F6E43;color:white';
      },
      isconceptosel(k) {
        return this.xconcetoschecks.includes(k.concepto_pago_id);
      },
      ismostrarFilaEstudiante(item){
        let idsel = this.xconcetoschecks[0];
        let k = item.detalle_asignacion.find(x=>x.concepto_pago_id==idsel);
        if(k) return (!this.hide_ceros || (!this.hide_ceros === k.xadd))
        return true;
      },
      showMoreDetails(item){
        //window.console.log('//////',item);
        this.$router.push({path:`/asignacion_prog_v2?idprograma=${item.idprograma}&name=${item.nombre_compuesto}`});
      },
      colspanconcepto(){
        let tam = 5;
        if(this.show_retrasado) tam += 3;
        if(this.show_recuperar) tam += 3;
        return tam;
      },
      irsumando(c, key, row) {
        // window.console.log(c,key,row);
       
        if (typeof c[key] != 'number') return; // solo suma numeros
        if (key == 'concepto_pago_id') return; // omitir este campo
        //window.console.log(c.concepto_pago_id, key);

        let existe = this.totales.find((x) => {
          return x.concepto_pago_id == c.concepto_pago_id;
        });
        
        if (!existe) {
          let ex = {
            concepto_pago_id: c.concepto_pago_id,
          };
          ex[key] = c[key];
          if (typeof row[key] == 'number') ex[key] = row[key];
         
          this.totales.push(ex);
        } else {
          if (existe[key] != null) {
            existe[key] += c[key];
          } else {
            existe[key] = c[key];
          }
          if (typeof row[key] == 'number') existe[key] += row[key];
        }
      },
      parsecomas(str) {
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
      
      obtenerasignaciones(sede_id,convenio, nro_cuota = 1, fecha = '', desde = true) {
        window.console.log("desde componente")
        const vue = this;
        this.xconceptos = [];
        this.xprogramas = [];
        this.xconcetoschecks = [];
        this.totales = [];
        let urla = `${process.env.VUE_APP_API_REST}/api/v3/esam/asignacion/cobranza/sedes?nro_cuota=${nro_cuota}&fecha=${fecha} 23:59&sede_id=${sede_id}&desde=${desde}&universidad_id=${convenio}`;
        const promise2 = xaxios.get(urla);

        Promise.all([promise2])
          .then(function(values) {
            let data1 = values[0];
            if (data1.data == '') data1.data = { data: [] };
            if (!data1.data) data1.data = { data: [] };
            if (!data1.data.data) data1.data.data = [];
            let datos = data1.data.data;
            datos.forEach((x) => {
              x.detalle_asignacion.forEach((d) => {
                let con = vue.xconceptos.find((cc) => cc.concepto_pago_id == d.concepto_pago_id);
                if (!con) vue.xconceptos.push(d);
              });
            });
            vue.xconceptos.sort((a, b) => {
              return a.concepto_pago_id - b.concepto_pago_id;
            });
            vue.xconceptos.forEach((c) => {
              datos.forEach((x) => {
                let tieneasig = x.detalle_asignacion.find((da) => da.concepto_pago_id == c.concepto_pago_id);
                if (!tieneasig) {
                  let xdefault = {
                    concepto_pago_id: c.concepto_pago_id,
                    descripcion: c.descripcion,
                    total_inscritos: 0,
                    total_retirados: 0,
                    total_cambiados: 0,
                    total_asignacion: 0,
                    total_por_cobrar: 0,
                    pagado_por_recuperar: 0,
                    pagado_retrasado: 0,
                    pagado_vigente: 0,
                    pago_adelantado: 0,
                    por_recuperar: 0,
                    retrasado: 0,
                    saldo_por_recuperar: 0,
                    saldo_retrasado: 0,
                    saldo_vigente: 0,
                    vigente: 0,
                    xshow: true,
                    xadd: true,
                  };
                  x.detalle_asignacion.push(xdefault);
                  
                } else {
                  tieneasig.xshow = true;
                  tieneasig.xadd = false;
                }
                x.detalle_asignacion.sort((a, b) => {
                  return a.concepto_pago_id - b.concepto_pago_id;
                });
              });
            });

            datos.forEach((x) => {
              x.detalle_asignacion.forEach((d) => {
                Object.keys(d).forEach((xc) => {
                  vue.irsumando(d, xc, x);
                });
              });
            });
            //window.console.log(JSON.stringify(datos, null, 2));
            vue.xprogramas = datos;

            vue.$emit('dataloaded');
          })
          .catch((e) => {
            window.console.error(e);
            vue.loading = false;
            if (e.response.status == 403) {
              vue.xmsg = 'Vuelva a acceder al sistema, su session ha caducado.';
            } else if (e.response.status == 500) {
              vue.xmsg =
                '(500) Actualmente estamos teniendo inconvientes al obtener los datos, lamentamos las molestias causadas :)';
            }
            vue.$emit('dataloaded');
          });
      },
    },
    mounted() {},
  };
</script>
